import axios from 'axios';
import { getAuthToken } from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const AUTH_TOKEN = 'FeMsA@2024';

export interface AppVersion {
  id?: number;
  platform: 'android' | 'ios';
  version: string;
  mandatory: boolean;
  enabled?: boolean;
  created_at?: string;
  updated_at?: string;
}

export const getAppVersions = async (): Promise<AppVersion[]> => {
  try {
    const response = await axios.get(`${API_URL}/app_versions`, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      timeout: 10000 // 10 segundos de timeout
    });
    return response.data;
  } catch (error) {
    console.error('Error en getAppVersions:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // El servidor respondió con un código de estado fuera del rango 2xx
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else if (error.request) {
        // La solicitud fue hecha pero no se recibió respuesta
        console.error('No se recibió respuesta del servidor');
      } else {
        // Algo sucedió al configurar la solicitud
        console.error('Error al configurar la solicitud:', error.message);
      }
    }
    throw error; // Relanzar el error para manejarlo en el componente
  }
};

export const getActiveAppVersions = async (): Promise<AppVersion> => {
  try {
    const response = await axios.get(`${API_URL}/app_versions/active`, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      timeout: 10000 // 10 segundos de timeout
    });
    return response.data;
  } catch (error) {
    console.error('Error en getActiveAppVersions:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
      } else if (error.request) {
        console.error('No se recibió respuesta del servidor');
      } else {
        console.error('Error al configurar la solicitud:', error.message);
      }
    }
    throw error;
  }
};

export const createAppVersion = async (version: Omit<AppVersion, 'id' | 'created_at' | 'updated_at'>): Promise<AppVersion> => {
  try {
    const response = await axios.post(`${API_URL}/app_versions`, version, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      timeout: 10000
    });
    return response.data;
  } catch (error) {
    console.error('Error en createAppVersion:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
      }
    }
    throw error;
  }
};

export const updateAppVersion = async (version: AppVersion): Promise<AppVersion> => {
  try {
    const response = await axios.put(`${API_URL}/app_versions`, version, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      timeout: 10000
    });
    return response.data;
  } catch (error) {
    console.error('Error en updateAppVersion:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
      }
    }
    throw error;
  }
};

export const deleteAppVersion = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/app_versions/${id}`, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      timeout: 10000
    });
  } catch (error) {
    console.error('Error en deleteAppVersion:', error);
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
      }
    }
    throw error;
  }
};
